import { render, staticRenderFns } from "./personalpage.vue?vue&type=template&id=1fed9238&scoped=true&"
import script from "./personalpage.vue?vue&type=script&lang=js&"
export * from "./personalpage.vue?vue&type=script&lang=js&"
import style0 from "./personalpage.vue?vue&type=style&index=0&id=1fed9238&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fed9238",
  null
  
)

export default component.exports